import { Schematic } from "../Schematic";
import { Scaffolder } from "./scaffold";
import { ScaffoldingData } from "./ScaffoldingData";

/**
 * Returns a new scaffolder with its data merged with the provided data.
 */
export function configScaffolder<TScaffoldingData extends ScaffoldingData>(
  scaffolder: Scaffolder<TScaffoldingData>,
  data: Partial<TScaffoldingData>,
): Scaffolder<TScaffoldingData> {
  return (schematic: Schematic, originalData: TScaffoldingData) =>
    scaffolder(schematic, { ...originalData, ...data });
}
